const { produce } = require("immer");
const { combineReducers } = require("redux");

const listReducer = require("./list");
const stateReducer = require("./state");

const formsReducer = require("./forms");
const projectReducer = require("./project");
const landingReducer = require('./landing');

const localeReducer = require('./locale');
const userReducer = require("./user");
const simtopyReducer = require("./simtopy");
const viewsReducer = require("./views");
const workspaces = require("./workspaces");

const initialState = {
  // UI Colors
  navigation: "init", // current user navigation location
};

/**
 * Top level Reducer
 */

function windowReducer(state = initialState, action) {
  switch (action.type) {
    /**
     * INIT
     */
    case "SHOW_SIMTOPY_INSTALLATION":
      return produce(state, draft => {
        draft.navigation = "install"
      })

    case "USER_AUTHENTICATED":
      return produce(state, draft => {
        draft.navigation = "home"
      });

    /**
      UPDATE
    **/

    case "UPDATE_NAVIGATION":
      return produce(state, draft => {
        draft.navigation = action.navigation;
      });

    default:
      return state;
  }
}

module.exports = combineReducers({
  window: windowReducer,
  user: userReducer,
  simtopy: simtopyReducer,
  state: stateReducer,
  list: listReducer,
  landing: landingReducer,
  forms: formsReducer,
  project: projectReducer,
  locale: localeReducer,
  views: viewsReducer,
  workspaces: workspaces.prod,
});
